import { keepPreviousData, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSocialCoachSession } from "./useSocialCoachSession";
import { PlayerSearchQuery, PlayersServices } from "../services/bedrock";

export const usePlayerSearch = () => {
  const { coachId } = useSocialCoachSession();
  const queryClient = useQueryClient();

  const searchPlayers = (params: PlayerSearchQuery, enabled: boolean = true) => {
    const sortedSegmentKeys = params.segmentationIds?.slice().sort() || [];
    const { data: players, isFetching } = useQuery({
      queryKey: [
        "coachPlayerList",
        coachId,
        params.searchTerm,
        params.planStatuses,
        params.planTiers,
        params.playerIds,
        sortedSegmentKeys,
        params.page,
        params.sort,
        params.sortDirection,
      ],
      queryFn: async () => {
        return PlayersServices.searchPlayers(params);
      },
      enabled: enabled && !!coachId,
      placeholderData: keepPreviousData,
      staleTime: 1000 * 60 * 5, // 5 minutes
    });
    return {
      players: enabled ? players : undefined,
      isFetching: enabled ? isFetching : false,
    };
  };

  const clearPlayerSearchCache = () => {
    queryClient.invalidateQueries({ queryKey: ["coachPlayerList", coachId] }).catch(console.error);
  };

  return {
    searchPlayers,
    clearPlayerSearchCache,
  };
};
